import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import {FolderActionsService} from '../../../../services/sp-folder/folder-actions.service';
import {UntypedFormControl, Validators} from '@angular/forms';

@Component({
  selector: 'app-sp-modal-project-list-folder-create',
  templateUrl: './sp-modal-project-list-folder-create.component.html',
  styleUrls: ['./sp-modal-project-list-folder-create.component.scss']
})
export class SpModalProjectListFolderCreateComponent implements OnInit {

  folderNameControl: UntypedFormControl = new UntypedFormControl('', Validators.required);

  constructor(
    public dialogRef: MatDialogRef<SpModalProjectListFolderCreateComponent>,
    private folderActions: FolderActionsService) { }

  ngOnInit() {
  }

  createFolder() {
    if (this.folderNameControl.valid) {
      this.folderActions.createFolder(this.folderNameControl.value).then(folder => {
        this.dialogRef.close(folder);
      })
    }
  }

  onNoClick(): void {
    this.dialogRef.close(null);
  }

}
